module.exports = {
      id: "youtubecolorround-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-cba8a2d7d36c4565ac7b4e175a8fc907.svg#youtubecolorround",
      toString: function () {
        return this.url;
      }
    }